import { TextTestID } from "@/constants/TestID";
import Button from "@/ui/core/buttons/Button";
import { FAIconName } from "@/ui/core/Icon";
import { SectionHeaderDimensions } from "@/ui/core/SectionHeader";
import Text from "@/ui/core/Text";
import { Box } from "@/ui/layout";
import { joinTestIDs } from "@/utils/string.util";

interface SecondarySectionHeaderProps extends ViewWithTestID {
  buttonTitle?: string;
  isInlineHeader?: boolean;
  onButtonPress?: () => void;
  title: string;
}

const SecondarySectionHeader = ({
  buttonTitle,
  isInlineHeader = true,
  onButtonPress,
  testID,
  title,
}: SecondarySectionHeaderProps) => {
  const baseTestID = joinTestIDs(testID, "section-header");

  return (
    <Box
      alignItems="center"
      flexDirection="row"
      gap={8}
      height={
        isInlineHeader ? "unset" : SectionHeaderDimensions.ScreenHeaderHeight
      }
      justifyContent="space-between"
      testID={baseTestID}
      width="100%"
    >
      <Text testID={joinTestIDs(baseTestID, TextTestID.Title)} variant="h5">
        {title}
      </Text>
      {buttonTitle && onButtonPress && (
        <Button
          onPress={onButtonPress}
          rightIcon={FAIconName.ChevronRight}
          testID={baseTestID}
          title={buttonTitle}
          variant="tertiary"
        />
      )}
    </Box>
  );
};

export type { SecondarySectionHeaderProps };
export default SecondarySectionHeader;
